export * as Api from './api';
export var TaxReliefDisplayMode;
(function (TaxReliefDisplayMode) {
    TaxReliefDisplayMode["Actual"] = "ACTUAL";
    TaxReliefDisplayMode["Forecast"] = "FORECAST";
})(TaxReliefDisplayMode || (TaxReliefDisplayMode = {}));
export var CompanyBreakdownDisplayMode;
(function (CompanyBreakdownDisplayMode) {
    CompanyBreakdownDisplayMode["SeparateTab"] = "SEPARATE-TAB";
    CompanyBreakdownDisplayMode["UnderSummaryTable"] = "UNDER-SUMMARY-TABLE";
})(CompanyBreakdownDisplayMode || (CompanyBreakdownDisplayMode = {}));
export var TileType;
(function (TileType) {
    TileType["SUBSCRIPTIONS"] = "subscription";
    TileType["MOIC"] = "MOIC";
    TileType["MULTIPLE"] = "multiple";
    TileType["DISTRIBUTABLE"] = "distributable";
    TileType["HELD_BY_MANAGER_AWAITING_INVESTMENT"] = "held-by-manager-awaiting-investment";
})(TileType || (TileType = {}));
export var InvestmentIdentifierDisplayMode;
(function (InvestmentIdentifierDisplayMode) {
    InvestmentIdentifierDisplayMode["ExternalInvestmentId"] = "EXTERNAL_INVESTMENT_ID";
    InvestmentIdentifierDisplayMode["SubscriptionDate"] = "SUBSCRIPTION_DATE";
})(InvestmentIdentifierDisplayMode || (InvestmentIdentifierDisplayMode = {}));
export var ShowSubscriptionPagePerformanceChartMode;
(function (ShowSubscriptionPagePerformanceChartMode) {
    ShowSubscriptionPagePerformanceChartMode["Always"] = "ALWAYS";
    ShowSubscriptionPagePerformanceChartMode["Never"] = "NEVER";
    ShowSubscriptionPagePerformanceChartMode["AfterDeployment"] = "AFTER_DEPLOYMENT";
})(ShowSubscriptionPagePerformanceChartMode || (ShowSubscriptionPagePerformanceChartMode = {}));
export var SyndicatesArrangement;
(function (SyndicatesArrangement) {
    SyndicatesArrangement["TaxYear"] = "taxYear";
    SyndicatesArrangement["CalendarYear"] = "calendarYear";
    SyndicatesArrangement["All"] = "all";
})(SyndicatesArrangement || (SyndicatesArrangement = {}));
export var NoSubscriptionsInvestorLandingPage;
(function (NoSubscriptionsInvestorLandingPage) {
    NoSubscriptionsInvestorLandingPage["Portal"] = "portal";
    NoSubscriptionsInvestorLandingPage["InvestmentOpportunitiesOrPortal"] = "investment-opportunities-or-portal";
})(NoSubscriptionsInvestorLandingPage || (NoSubscriptionsInvestorLandingPage = {}));
//# sourceMappingURL=index.js.map